<template>
    <footer class="footer footer-home" style="margin:0!important">
        <footer id="footer" class="footer solid-bg nitro-offscreen">
            <div class="wf-wrap">
                <div class="wf-container-footer">
                    <div class="wf-container">
                        <section id="text-2" class="widget widget_text wf-cell wf-1-2">
                            <div class="textwidget"><h6><img style="max-width:150px;" alt="Cohn Legal, PLLC"
                                                             nitro-lazy-src="/images/logo-2021.png"
                                                             class="alignnone size-full wp-image-47 ls-is-cached lazyloaded"
                                                             decoding="async" nitro-lazy-empty="" id="MzAwMzoyNjE=-1"
                                                             src="/images/logo-2021.png">
                            </h6> <h5>Our New York Startup and Trademark Lawyers operate with the singular goal of acting as
                                your legal consigliere, continuously striving to provide you with the best legal advice and
                                strategies to protect your interests.</h5></div>
                        </section>
                        <section id="text-3" class="widget widget_text wf-cell wf-1-6">
                            <div class="widget-title">Trademarks</div>
                            <div class="textwidget">
                                <p>
                                    <RouterLink to="trademark-office-action">
                                        Office Action
                                    </RouterLink>
                                    <br>
                                    <RouterLink to="statement-of-use">
                                        Statement of Use
                                    </RouterLink>
                                    <br>
                                    <RouterLink to="trademark-revival">
                                        Abandonment
                                    </RouterLink>
                                    <br>
                                    <RouterLink to="free-uspto-trademark-search">
                                        Search TM
                                    </RouterLink>
                                </p>
                            </div>
                        </section>
                        <section id="text-4" class="widget widget_text wf-cell wf-1-6">
                            <div class="widget-title">Resources</div>
                            <div class="textwidget">
                                <p>
                                    <RouterLink to="/trademark-faqs">
                                        Trademark FAQ
                                    </RouterLink>
                                    <br>
                                    <RouterLink to="/flat-fee-trademark-registration-package">
                                        File Trademark <br>Application
                                    </RouterLink>
                                </p>
                            </div>
                        </section>
                        <section id="text-5" class="widget widget_text wf-cell wf-1-6">
                            <div class="widget-title">Get Started</div>
                            <div class="textwidget">
                                <p>
                                    <RouterLink to="/about">
                                        Our Firm
                                    </RouterLink>
                                    <br>
                                    <RouterLink to="/contact-us">
                                        Contact us
                                    </RouterLink>
                                    <br>
                                    <RouterLink to="/were-international">
                                        International
                                    </RouterLink>
                                </p>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <div class="wf-wrap">
                <div class="ll-container-footer">
                    <div class="ll-footer-btns"><a class="ll-btn3" href="tel:+2122030957"
                                                   style="max-width:320px;border-bottom:0px;padding-bottom:0px;">
                        <div class="ll-btn3-top ll-btn3-top-footer">
                            <div class="ll-btn3-icon-wrap">
                                <div class="ll-btn3-icons">
                                    <div class="ll-btn3-icon"><i class="fa fa-phone" style="color:#00c1cf;"
                                                                 aria-hidden="true"></i></div>
                                    <div class="ll-btn3-icon"><i class="fa fa-phone" style="color:#00c1cf;"
                                                                 aria-hidden="true"></i></div>
                                </div>
                            </div>
                            <span class="ll-btn3-text" style="color:#ffa500;font-size:18px;line-height:20px;">PH: (212) 203-0957 <br><small>Monday - Friday<span
                                class="ll-divider">|</span><br class="ll-br"> 8:30 AM - 6:00 PM</small></span></div>
                    </a></div>
                    <img style="height:80px;" alt="Website Secured by Let's Encrypt"
                         class=" lazyloaded" decoding="async" nitro-lazy-empty="" id="MzA0MjoxMzE=-1"
                         src="/images/iu.png">
                </div>
            </div>
            <div id="bottom-bar" class="logo-left" role="contentinfo">
                <div class="wf-wrap">
                    <div class="wf-container-bottom">
                        <div class="wf-float-left"> ©
                            <wbr>
                            <wbr>
                            {{ new Date().getFullYear() }} Cohn Legal, PLLC. All Rights Reserved. <a
                                href="https://www.cohnlg.com/cohn-legal-pllc-website-legal-notices-terms-of-use/">Privacy
                                Policy</a>.
                        </div>
                        <div class="wf-float-right">
                            <div class="bottom-text-block"><p>Be Great. Rise Together</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <div class="footer__bottom">
            <div class="footer__bottom-inner">
                <div class="footer__bottom-legal ">
                    <ul>
                        <li>Cohn legal, PLLC 2019-{{ new Date().getFullYear() }}</li>
                        <li><RouterLink to="terms-of-use">Terms of Use</RouterLink></li>
                        <li><RouterLink to="privacy-policy">Privacy Policy</RouterLink></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {}
</script>


<style lang="css" scoped src="@/styles/header/fonts.css"></style>
<style lang="css" scoped src="@/styles/home.css"></style>

<style scoped>


/*! CSS Used from: https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/optimized/rev-01a9c53/combinedCss/nitro-min-noimport-fdeacbf5c2cf71365813e38df5666747-stylesheet.css */
html :where(img[class*=wp-image-]){height:auto;max-width:100%;}

footer,section{display:block;}
*{padding:0;margin:0;}
a:active,a:focus,a:hover{outline:0;}
small{font-size:75%;}
img{border:0;-ms-interpolation-mode:bicubic;}
.footer{-ms-grid-column:1;-ms-grid-row:6;grid-area:footer;}
.wf-cell,.wf-wrap{box-sizing:border-box;}
.footer .widget,.wf-cell{display:inline-block;vertical-align:top;padding:0 22px;}
.wf-1-2{width:50%;}
.wf-1-6{width:16.6667%;}
.wf-float-left{float:left;}
.wf-float-right{float:right;}
.wf-container{font-size:0;line-height:0;word-spacing:-4px;margin:0 -22px;padding:0;}
.wf-wrap{max-width:100%;padding:0 44px;margin:0 auto;}
.footer .widget{margin-bottom:30px;}
.widget:after,.widget:before{content:"";display:table;clear:both;}
.widget-title{margin-bottom:15px;clear:both;}
.textwidget a{text-decoration:none;}
.textwidget img{max-width:100%;height:auto;}
.textwidget *{max-width:100%;}
.textwidget p:last-child{margin-bottom:0;}
h5,h6{margin-bottom:10px;clear:both;}
a:hover{text-decoration:none;}
p{margin-bottom:10px;}
a{text-decoration:underline;}
img[class*=align],img[class*=wp-image-]{max-width:100%;height:auto;}
.alignnone{float:none;margin:0 auto 10px;}
.wf-container:before{content:"";display:table;}
.wf-container:after{content:"";display:table;clear:both;}
.footer{padding:0;}
.footer.solid-bg .wf-container-footer{border-top:none;}
.wf-container-footer{padding-top:50px;}
.footer .widget{box-sizing:border-box;}
#bottom-bar{position:relative;z-index:9;margin:0 auto;}

#bottom-bar .wf-container-bottom {
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    -ms-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-justify-content: space-between;
    justify-content: space-between;
    box-sizing: border-box;
}

#bottom-bar p{margin-bottom:0;}
.bottom-text-block{text-align:right;}
#bottom-bar .wf-float-left{margin-right:10px;}

#bottom-bar .wf-float-right {
    display: -ms-flexbox;
    display: -ms-flex;
    display: flex;
    flex-grow: 1;
    -ms-justify-content: flex-end;
    justify-content: flex-end;
    margin-left: 10px;
    margin-right: 0;
}

#bottom-bar a{text-decoration:none;}
#bottom-bar a:hover{text-decoration:underline;}

#page .fa{font-family:"Font Awesome 5 Free";font-weight:900;}
#page .fa:before{font-weight:inherit;}
.wf-container > *{font:normal 19px/27px "Lato",Helvetica,Arial,Verdana,sans-serif;word-spacing:normal;color:#505c62;}
.wf-container{margin:0 -50px 0 -50px;}
.wf-cell{padding:0 50px 0 50px;}
#footer .wf-wrap{padding:0 50px 0 50px;}
h5{color:#333;font:normal 300 14px/26px "Montserrat",Helvetica,Arial,Verdana,sans-serif;text-transform:none;}
h6{color:#333;font:normal 300 17px/24px "Montserrat",Helvetica,Arial,Verdana,sans-serif;text-transform:none;}
h5,h6{color:#333;}
.footer h5,.footer h6{color:#303030;}
a,a:hover{color:#1ebbf0;}
#bottom-bar > .wf-wrap,#footer > .wf-wrap{width:1300px;}
.widget-title{font:300 14px/26px "Montserrat",Helvetica,Arial,Verdana,sans-serif;text-transform:none;color:#333;}
.footer .widget-title{color:#303030;}
.widget-title{margin-bottom:15px;}
.footer .widget a{color:#6b6b6b;}
.textwidget a{color:#333;}
.footer .textwidget a{color:#303030;}
.textwidget a:not(.dt-btn):hover{color:#45d9e6;}
.footer .textwidget a:not(.dt-btn):hover{color:#45d9e6;}
#footer.solid-bg{background:#fff none repeat center top;}
.wf-container-footer{border-top:1px solid #fff;}
#footer .wf-container-footer{padding-top:60px;padding-bottom:25px;}
#footer .wf-container{margin:0 -25px;}
.footer .widget{color:#6b6b6b;padding:0 25px;}
.footer .widget{font:14px/25px "Lato",Helvetica,Arial,Verdana,sans-serif;text-transform:none;}
#footer > .wf-wrap,#footer #bottom-bar > .wf-wrap{padding:0 50px 0 50px;}
.wf-container-bottom{border-top:1px solid #d8d8d8;}
.wf-container-bottom{padding:10px 0 10px 0;min-height:60px;}
#bottom-bar{font-size:13px;line-height:23px;color:#5b5b5b;}
#bottom-bar a{color:#5b5b5b;}
@media screen and (max-width: 778px){
    #footer .wf-container-footer{padding-top:60px;padding-bottom:25px;}
    #footer > .wf-wrap,#footer #bottom-bar > .wf-wrap{padding:0 20px 0 20px;}
}
@media screen and (max-width: 778px){
    .footer .widget{width:100%;}
}
@media screen and (max-width: 990px){
    #bottom-bar .wf-container-bottom{-ms-flex-flow:column wrap;flex-flow:column wrap;-ms-flex-pack:center;-ms-justify-content:center;justify-content:center;}
    #bottom-bar .wf-container-bottom > div{margin:0;}
    #bottom-bar .wf-float-left,#bottom-bar .wf-float-right{display:block;float:none;width:auto;padding-left:0;padding-right:0;margin-right:auto;margin-left:auto;text-align:center!important;}
    #bottom-bar .bottom-text-block{text-align:center;margin-left:0;}
}
@media screen and (max-width: 778px){
    .wf-cell{padding:0 10px 0 10px;}
}
/*! CSS Used from: Embedded */
#footer .wf-container-footer{padding-bottom:0px;}
.ll-container-footer{padding-bottom:20px;display:flex;justify-content:space-between;align-items:center;}
.ll-footer-btns{align-items:center;display:flex;width:100%;height:40px;justify-content:flex-end;padding-right:40px;}
.ll-divider{padding:0px 10px;}
.ll-br{display:none;}
.ll-btn3{display:block;display:inline-block;width:100%;border-bottom:1px solid orange;align-self:auto;padding-bottom:35px;overflow:hidden;text-decoration:none;color:orange;transition-duration:500ms;transition-timing-function:ease;transition-delay:0ms;transition-property:all;}
.ll-btn3 .ll-btn3-top{display:flex;justify-content:space-between;align-items:center;}
.ll-btn3 .ll-btn3-top .ll-btn3-text{font-size:36px;line-height:40px;}
.ll-btn3 .ll-btn3-top .ll-btn3-icon-wrap{box-sizing:border-box;float:right;width:44px;display:block;transform:none;overflow-x:hidden;overflow-y:hidden;}
.ll-btn3 .ll-btn3-top .ll-btn3-icon-wrap .ll-btn3-icons{box-sizing:border-box;transition-duration:500ms;transition-timing-function:ease;transition-delay:80ms;transition-property:all;width:7em;transform:translateX(-90px);animation-timing-function:cubic-bezier(.4,0,.2,1);display:flex;-webkit-box-pack:justify;justify-content:space-between;}

.ll-btn3 .ll-btn3-top .ll-btn3-icon-wrap .ll-btn3-icons .ll-btn3-icon {
    box-sizing: border-box;
    font-size: 44px;
    color: orange;
    transition-duration: 1500ms;
    transition-timing-function: ease;
    transition-delay: 80ms;
    transition-property: all;
    animation-timing-function: cubic-bezier(.4, 0, .2, 1);
    width: 44px;
    overflow-x: hidden;
    overflow-y: hidden;
}

.ll-btn3:hover{color:#00c1cf;border-color:#00c1cf;}
.ll-btn3 .ll-btn3-top .ll-btn3-icon-wrap .ll-btn3-icons{transform:translateX(0px);}
.ll-fa-rotate-90{-webkit-transform:rotate(90deg);-moz-transform:rotate(90deg);-ms-transform:rotate(90deg);-o-transform:rotate(90deg);transform:rotate(90deg);}
@media only screen and (max-width: 768px){
    .ll-btn3-top-footer{justify-content:space-evenly!important;}
    .ll-divider{display:none;}
    .ll-br{display:block;}
    .ll-footer-btns,.ll-container-footer{flex-direction:column;}
    .ll-footer-btns{height:200px;justify-content:space-around;padding-right:0px;}
}
/*! CSS Used from: Embedded */
.widget-title{font:normal 400 18px/26px "Nunito",Helvetica,Arial,Verdana,sans-serif;}
.footer .widget{font-size:16px;line-height:40px;color:#999;}
#bottom-bar > .wf-wrap,#footer > .wf-wrap{width:1480px;}
a{text-decoration:none!important;}
.widget-title{font:normal 400 22px/26px "Nunito",Helvetica,Arial,Verdana,sans-serif;}
/*! CSS Used fontfaces */
@font-face{font-family:Font Awesome\ 5 Free;font-style:normal;font-weight:400;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-01a9c53/wp-content/plugins/blog-designer//admin/fonts/fa-regular-400.woff2") format("woff2");font-display:swap;}
@font-face{font-family:Font Awesome\ 5 Free;font-style:normal;font-weight:900;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-01a9c53/wp-content/plugins/blog-designer//admin/fonts/fa-solid-900.woff2") format("woff2");font-display:swap;}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-01a9c53/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-01a9c53/wp-content/plugins/mega-addons-for-visual-composer/css/font-awesome/webfonts/fa-solid-900.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-01a9c53/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-regular-400.woff2") format("woff2");}
@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:swap;src:url("https://cdn-cohgd.nitrocdn.com/jhUWCDjkDRqSFvtaqPwhyOKnFHhDyxru/assets/static/source/rev-01a9c53/wp-content/themes/dt-the7/fonts/FontAwesome/webfonts/fa-solid-900.woff2") format("woff2");}

.textwidget a {
    font-family: 'Lato';
    font-size: 16px;
}
.wf-container-bottom .wf-float-left {
    font-family: 'Lato';
}
.wf-container-bottom .bottom-text-block p{
    font-family: 'Lato';
    font-size: 13px;
}
</style>
